/**
 * ChatMessageType enum
 * Defines the type of chat message
 * Matches Flutter implementation: lib/domain/enums/chat_message_type.dart
 */
export enum ChatMessageType {
  text = 0,
  image = 1,
  video = 2,
  gift = 3,
  reply = 4,
  videoCall = 5,
  shareUser = 6,
  sharePhoto = 7,
  shareVideo = 8,
}
